import { Modal } from "antd";
import styled from "styled-components";

export const RXWrapperContainer = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1em;
  padding: 16px 0;
`;

export const DoctorPrescriptionModal = styled(Modal)`
  .doctorRxContainer {
    width: 100%;
    max-width: 600px;
    margin: 0 auto;
    display: flex;
    flex-flow: column;
    gap: 1em;
    justify-content: center;
  }
`;
